export default function useFormState(form: { [key: string]: any }) {
  const formState = ref<string>('{}')

  const isFormUpdated = computed(() => {
    return JSON.stringify(form) !== formState.value
  })

  const saveFormState = () => {
    formState.value = JSON.stringify(form)
  }

  // Initialize form state on load
  saveFormState()

  return {
    formState,
    isFormUpdated,
    saveFormState,
  }
}
